export let data = {
  title: "Tebus Resep Optik",
  backBtn: "/optik",
  actionBtn: [],
  breadcrumb: [
    { title: "Optik", link: "/optik" },
    { title: "Tebus Resep Optik", active: true }
  ]
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6
      }
    ]
  }
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps"
  }
];
